import React, { useState } from 'react'
import {
    makeStyles,
    Box,
    IconButton,
    Link,
    useTheme,
    useMediaQuery,
} from '@material-ui/core'
import Logo from "../images/logo/SugarCribs.svg";
import Logo_pink from "../images/logo/SugarCribs_pink.svg";
import { ContainedButton, OutlinedButton } from './elements/Buttons';
import { MenuIcon, X } from 'lucide-react';
import { MobileNavigation } from './MobileNavigation';
import { useIsCreatorsPage } from '../hooks/useIsCreatorsPage';

const useStyles = makeStyles((theme) => ({
    // Header
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(2, 4),
        backgroundColor: "#111111",
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(2)
        }
    },
    logo: {
        fontSize: '1.5rem',
        fontWeight: 500,
        color: '#ffffff',
        textDecoration: 'none',
    },
    nav: {
        display: 'flex',
        alignItems: 'center',
        gap: 20,
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    navLink: {
        color: '#ffffff',
        textDecoration: 'none',
        fontSize: '16px',
        fontWeight: 400,
        opacity: 0.9,
        transition: 'opacity 0.2s',
        '&:hover': {
            opacity: 0.7,
            textDecoration: 'none',
            color: '#ffffff',
        },
    },

    wideButton: {
        width: "100%"
    },
}))

export default function Header() {
    const classes = useStyles()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const isCreatorsPage = useIsCreatorsPage();

    const navigationList = [
        {
            title: 'Discover',
            to: '#discover',
        },
        {
            title: 'The Vault',
            to: '#vault',
        },
        {
            title: 'Genesis Collection',
            to: '#collection',
        },
        {
            title: 'Join the Waitlist',
            to: '#waitlist',
        },
    ]

    return (
        <Box component="header" className={classes.header} >
            <Link href="#" className={classes.logo}>
                <img src={isCreatorsPage ? Logo_pink : Logo} alt="icon" width={141} height={32} />
            </Link>
            <Box component="nav" className={classes.nav}>
                {navigationList.map(item => (
                    <Link href={item.to} key={item.title} className={classes.navLink}>{item.title}</Link>
                ))}
                <OutlinedButton text="Log In" to="/login" />
                <ContainedButton text="Apply as Creator" />
            </Box>

            {
                isMobile && <IconButton
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                    {mobileMenuOpen ? <X size={24} /> : <MenuIcon size={24} />}
                </IconButton>
            }

            <MobileNavigation
                open={mobileMenuOpen}
                onClose={() => setMobileMenuOpen(false)}
                side="bottom"
                width="100%"
                items={navigationList}
                footerItems={[
                    <OutlinedButton text="Log In" to="/login" styles={classes.wideButton} />,
                    <ContainedButton text="Apply as Creator" styles={classes.wideButton} />
                ]}
            />
        </Box>
    )
}
